// Import the functions you need from the SDKs
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyClzvLBqZPRtSuZgdL3AOlJnDpKiJOLdPU",
  authDomain: "wasaela-foundation.firebaseapp.com",
  projectId: "wasaela-foundation",
  storageBucket: "wasaela-foundation.appspot.com",
  messagingSenderId: "1072832042734",
  appId: "1:1072832042734:web:2440b5458f57e6ddbe45ff",
  measurementId: "G-R3B2SMXCH0",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db };